// extracted by mini-css-extract-plugin
export var blue = "_2n-f";
export var brand = "_2n-b";
export var darkGrey = "_2n-e";
export var disabled = "_2n-4";
export var disabledSubtle = "_2n-5";
export var error = "_2n-6";
export var green = "_2n-g";
export var grey = "_2n-d";
export var icon = "_2n-0";
export var inherit = "_2n-a";
export var lightGrey = "_2n-c";
export var orange = "_2n-i";
export var pink = "_2n-k";
export var primary = "_2n-1";
export var purple = "_2n-l";
export var red = "_2n-j";
export var secondary = "_2n-2";
export var success = "_2n-9";
export var tertiary = "_2n-3";
export var warning = "_2n-7";
export var warningSecondary = "_2n-8";
export var white = "_2n-m";
export var yellow = "_2n-h";